import React from 'react'

import {FieldType} from "../../../../fields3/field-type"
import FieldsFactory from "../../../../fields3/fields-factory"
import {Field2Groups} from "../../../../gd/const/fields/field2-groups"
import ItemViewTop from "../../../../../layout/top/item-view-top/item-view-top"
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import AddCustomFieldHeader from "../../custom-field/create-new/components/header"
import AddCustomFieldGroup from "../../custom-field/create-new/components/fields-group"

type Props = {
    onSelectType    : any,
    onCloseClick?   : {(e?:any):void},
}

export default class SelectFieldType extends React.Component<Props> {

    onClick = (e:any) => {
        e.stopPropagation()
        e.preventDefault()
    }

    getFieldTypes = () => {

        const fields = [
            FieldType.STRING,
            FieldType.TEXT,
            FieldType.CHECKBOX,
            FieldType.TOGGLE,
            FieldType.NUMBER,
            FieldType.CURRENCY,
            FieldType.PERCENTAGE,
            FieldType.DATE,
            FieldType.DATE_RANGE,
            FieldType.DROPDOWN,
            FieldType.MULTISELECT,
            FieldType.COLOR,
            FieldType.USER,
            FieldType.USERS,
            FieldType.RATING,
            FieldType.RAG,
            FieldType.EMAIL,
            FieldType.PHONE,
            FieldType.URL,
            FieldType.ATTACHMENT,
            FieldType.ADDRESS,
            FieldType.TIME_OF_DAY,
            FieldType.DATE_AND_TIME,

        ].map(fieldType=>{
            return FieldsFactory.get({
                type: fieldType,
                fieldId: fieldType
            })
        })

        const fieldTypes:any = [];
        fields.map(field=>{
            fieldTypes.push({
                id          : field.fieldId,
                icon        : field.icon,
                name        : field.typeLabel,
                group       : field.typeGroup,
                color       : field.typeGroup ? Field2Groups[field.typeGroup].color : 'blue',
                description : field.typeDescription
            })
        })

        const groupsOrder:any = [];
        _.mapKeys(gd.const.customFields.groups,(value,key)=>groupsOrder.push(key))

        return _.chain(fieldTypes)
            .groupBy(t=>t.group)
            .toPairs()
            .map(group=>({
                id      : group[0],
                name    : gd.const.customFields.groupLabel[group[0]],
                items   : group[1]
            }))
            .sortBy(group=>_.indexOf(groupsOrder, group.id))
            .value();
    }

    render() {
        const groupedItems = this.getFieldTypes();

        return (
            <div className="v4-container placement-middle ui5-iv view-custom-field-selector" style={{width: 840}} onClick={this.onClick}>
                <ItemViewTop title          = "New custom field"
                             onCloseClick   = {this.props.onCloseClick}/>

                <div className="iv-selector">
                    <VScroll>
                        <AddCustomFieldHeader/>

                        <div className="iv-content without-left-panel iv-paddings">
                            {_.map(groupedItems, group=>
                                <AddCustomFieldGroup key            = {group.id}
                                                     name           = {group.name}
                                                     items          = {group.items}
                                                     onSelectType   = {this.props.onSelectType}/>)}
                        </div>
                    </VScroll>
                </div>
            </div>
        )
    }
}
